export default __webpack_public_path__ + "contoh-notifikasi.png";